import React from 'react';
import { Route, Switch, withRouter } from "react-router-dom";
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import authenticationService from '../../authenticationService';
import CustomerPortalAction from '../../actions/CustomerPortalAction';
import _ from 'lodash';
import { FEATURES_ROUTE_MAPPING } from './constants';
const $ = require('jquery');

export const routeMapping = {
    login: { path: '/login', filePath: './ManageAccount/Login', desc: 'Login', canAnonymous: true },
    salesperson: { path: '/salesperson', filePath: './Salesperson/Salesperson', desc: 'Salesperson' },
    activity: { path: '/activity', filePath: './AccountActivity/AccountActivityContainer', desc: 'Account Activity', },
    transactions: { path: '/transactions', filePath: './ViewTransactions/ViewTransactionContainer', desc: 'View Transactions', },
    payment: { path: '/payment/:status?/:code?', filePath: './PayAccount/PayAccountContainer', desc: 'Pay Account', },
    prepayment: { path: '/prepayment', filePath: './Prepayment/PrePaymentContainer', desc: 'Prepayment', },
    orders: { path: '/orders', filePath: './ViewTransactions/ViewOrderContainer', desc: 'View Orders', },
    manageCredt: { path: '/manage', filePath: './ManageCreditCards/ManageCreditCards', desc: 'Manage Credit Cards', },
    contactus: { path: '/contactus', filePath: './ContactUs/ContactUs', desc: 'Contact Us', },
    password: { path: '/password', filePath: './ManageAccount/ChangePassword', desc: 'Change Password', },
    myAccount: { path: '/account', filePath: './ManageAccount/MyAccount', desc: 'My Account', },
    resetpassword: { path: '/resetpassword/:token?/', filePath: './ManageAccount/ResetPassword', desc: 'Reset Password', canAnonymous: true },
    transactionDetail: { path: '/transactions/:docInfo', filePath: './ViewDocuments/ViewDocumentDetails', desc: 'View Transactions', },
    orderDetails: { path: '/orders/:docInfo', filePath: './ViewDocuments/ViewDocumentDetails', desc: 'View Orders Details', },
    receipt: { path: '/receipt/:id?', filePath: './ClickToPay/ClickToPaySuccess', desc: 'Payment Receipt', canAnonymous: true },
    slack: { path: '/slack/:url?', filePath: './Notification/Slack', desc: 'Slack', canAnonymous: true },
    quickpay: { path: '/quickpay', filePath: './ClickToPay/ClickToPay', desc: 'Click To Pay', canAnonymous: true },
    orderentry: { path: '/order', filePath: './OrderEntry/OrderEntry', desc: 'Order Entry' },
    superuser: { path: '/superuser/:token/:id', filePath: './Superuser', desc: 'superuser', canAnonymous: true  },
    home: { path: '/', filePath: './MerchantHome', desc: 'Home', },
    // error: { path: '*', notExact: true, filePath: './NoMatch', desc: '404 Not Found', canAnonymous: true },
};

export function getRouteInfo(target) {
    if (routeMapping[target]) {
        return {
            //special case for payment because of the optional passback param
            path: (target !== 'payment' ? routeMapping[target].path : '/payment'),
            desc: routeMapping[target].desc,
        }
    }
}
function canAnonymous(route) {
    let routeName = route.split('/')[1];
    if (routeMapping[routeName] && routeMapping[routeName].canAnonymous) {
        return true;
    } else {
        return false;
    }
}
// function CustomRouter({ match, location, history, ...props }) {
class CustomRouter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          activeRoute: '',
          baseTitle: "",//("Customer Portal" + " - "),
          hasError: false,
          isLoading: true,
          routeMapping: routeMapping
        }
        if (sessionStorage.history) sessionStorage.removeItem('history');
        this.validateLogin(this.props.location);
        CustomerPortalAction.getCustomizationList().then(function(customization){
          let routeMapping = this.state.routeMapping;
          localStorage.setItem('customization',JSON.stringify(customization));
           Object.keys(customization).map((value,key)=>{
             let cus = customization[value];
             routeMapping[cus.name] = { path: '/'+cus.url, filePath: './CustomPage/Custom', desc: cus.displayName }
           })
           routeMapping['error'] = { path: '*', notExact: true, filePath: './NoMatch', desc: '404 Not Found', canAnonymous: true }
           this.setState({isLoading: false,routeMapping:routeMapping});
        }.bind(this));
    }
    validateLogin(location) {
        /*
            check login status here, so each time user change page can validate his status
            */
        let authorization = authenticationService();
        let isLoggedIn = !(typeof authorization === "object");
        let anonymousRoutes = canAnonymous(location.pathname);
        let user = JSON.parse(localStorage.currentUser||sessionStorage.currentUser||'{}');
        let history = JSON.parse(sessionStorage.history||null) || new Array(5);
        let openpages = (localStorage.openpages)?(JSON.parse(localStorage.openpages)):({});
        let pageID = sessionStorage.pageID;
        openpages[pageID] = new Date().getTime();
        localStorage.setItem('openpages', JSON.stringify(openpages));
        if (!isLoggedIn && !anonymousRoutes) {
            this.props.history.replace('/login');
            history.push('/login');
        } else if (user.userType == "Merchant"){
            window.location.replace('/merchant');
        } else if (user.userType == "Admin"){
            window.location.replace('/admin');
        } else if(isLoggedIn && user.userType == 'Salesperson' && (history[4] == undefined)) {
            let client = (localStorage.client)? (JSON.parse(localStorage.client)) : (undefined) ;
            if(!client){
              this.props.history.replace('/salesperson');
              history.push('/salesperson');
            }
        } else {
            let features = user.features;
            let routePath = location.pathname.split('/')[1];
            let featureList = FEATURES_ROUTE_MAPPING;
            let featureKey = _.findKey(FEATURES_ROUTE_MAPPING,["pathName",routePath]);
            if((user && user.features && featureKey && (user.features.indexOf(featureKey) >= 0)) || !(Object.keys(featureList).indexOf(featureKey)>=0)){
              history.push(location.pathname);
            } else if (routePath == "contactus" || routePath == "quickpay") {
              history.push(location.pathname);
            } else {
              this.props.history.replace('/404');
              history.push('/404');
            }
        }
        history.shift();
        sessionStorage.setItem('history', JSON.stringify(history));
        $('div[id^=__lpform_]').remove();
    }
    componentDidUpdate(prevProps, prevState) {
        let routes = Object.keys(this.refs);
        let companyName = document.getElementById('companyName').value;
        let route = (routes[0] === prevState.activeRoute) ? (routes[1]) : (routes[0]);
        if (route && route != this.state.activeRoute) {
            this.setState({ activeRoute: route });
            document.title = this.state.baseTitle + ((companyName) ? (companyName + ' - ') : ('')) + routeMapping[route].desc;
        }
    }
    componentDidCatch(error, info) {
      console.log(error)
      let page = JSON.parse(sessionStorage.history || null)[4];
      this.setState({hasError:true});
      CustomerPortalAction.sendErrorLog(page,error,info);
    }
    componentWillUnmount() {
        this.unlisten();
    }
    render() {
      if(this.state.isLoading) return false;
        return (
            <TransitionGroup className="transition-group">
                <CSSTransition
                    key={this.props.location.pathname}
                    timeout={{ enter: 500, exit: 300 }}
                    classNames="page"
                >
                    {this.state.hasError?(
                      <div className='div-error text-center d-flex justify-content-center align-items-center'>
                        <div>
                          <div className='mb-4'>Something unexpected has occurred, please try again later.</div>
                          <button className='btn btn-custom' onClick={()=>{this.setState({hasError:false});this.props.history.replace('/');}}>Back To Home</button>
                        </div>
                      </div>
                    ):(
                      <section className='div-container'>
                        <React.Suspense fallback={false}>
                          <Switch location={this.props.location}>
                            {Object.keys(this.state.routeMapping).map((item, i) => {
                              if(item == "error") return false;
                              return (
                                <Route
                                  key={item}
                                  ref={item}
                                  exact={!this.state.routeMapping[item].notExact || true}
                                  path={this.state.routeMapping[item].path}
                                  component={React.lazy(() => import(`${this.state.routeMapping[item].filePath}`))}
                                />
                              )
                            })}
                          </Switch>
                        </React.Suspense>
                      </section>
                    )}
                </CSSTransition>
            </TransitionGroup>
        );
    }
};
export default withRouter(CustomRouter);
